import { render } from "./ChevronUp.vue?vue&type=template&id=d07f112c"
import script from "./ChevronUp.vue?vue&type=script&lang=js"
export * from "./ChevronUp.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/ChevronUp.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d07f112c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d07f112c', __exports__)) {
    api.reload('d07f112c', __exports__)
  }
  
  module.hot.accept("./ChevronUp.vue?vue&type=template&id=d07f112c", () => {
    api.rerender('d07f112c', render)
  })

}


export default __exports__